import React from 'react'
import { Box } from '@node-space/storybook-components/dist/Box'
import { Text } from '@node-space/storybook-components/dist/Text'
import { Avatar } from '@node-space/ui-components'
import { CustomerWallet } from 'types/customers'

interface CustomerWalletSidePanelHeaderProps {
  customerWalletData: CustomerWallet
}

const CustomerWalletSidePanelHeader = ({
  customerWalletData,
}: CustomerWalletSidePanelHeaderProps) => {
  return (
    <Box width="full" flex direction="row" className="py-3">
      <Avatar size="large" name={customerWalletData?.balance?.currencyCode || ''} />

      <Box flexSize="fill" paddingL={16} gapY={4}>
        <Text size="xl" className="leading-5">
          {customerWalletData?.name}
        </Text>
        <Text size="xs" color="text-500" className="leading-5">
          {`${customerWalletData?.balance?.value} ${customerWalletData?.balance?.currencyCode}`}
        </Text>
      </Box>
    </Box>
  )
}

export default CustomerWalletSidePanelHeader
